<template>
    <div
        v-if="!dismissed && (!isDone || isValid)"
        class="validation-progress-box"
        :class="{
            'validation-progress-box-running': !isDone,
            'validation-progress-box-success': isDone,
        }"
    >
        <div class="d-flex justify-content-between align-items-center">
            <span class="validation-title">{{ isDone ? 'Proses Validasi Selesai' : 'Sedang Proses Validasi' }}</span>
            <div class="d-flex align-items-center">
                <span class="validation-count mr-4">{{ validated }} dari {{ total }}</span>
                <button v-if="!isDone" class="btn refresh-btn" :disabled="loading" @click="$emit('refresh')">
                    <i class="fas fa-sync-alt" :class="{ 'fa-spin': loading }"></i> Refresh
                </button>
                <button
                    v-if="isDone"
                    type="button"
                    class="close-btn"
                    aria-label="Close"
                    @click="dismissed = true"
                >&times;</button>
            </div>
        </div>
        <div class="progress-track mt-2" :class="{ 'progress-track-inset': isDone }">
            <div class="progress-fill" :style="{ width: percent + '%' }"></div>
        </div>
        <p class="validation-note mb-0">
            <span class="info-icon">&#9432;</span>
            <template v-if="isDone">
                Semua data valid dan siap diproses ke tahap berikutnya.
            </template>
            <template v-else>
                Prosesmu sedang berjalan di latar belakang. Klik <strong>Refresh</strong> untuk memantau perkembangannya.
            </template>
        </p>
    </div>
</template>

<script>
export default {
    name: 'ValidationProgressBox',
    props: {
        total: {
            type: Number,
            default: 0,
        },
        validated: {
            type: Number,
            default: 0,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        isValid: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            dismissed: false,
        };
    },
    computed: {
        isDone() {
            return this.validated >= this.total;
        },
        percent() {
            if (!this.total) return 0;
            return Math.min(100, Math.round((this.validated / this.total) * 100));
        },
    },
};
</script>

<style scoped>
.validation-progress-box {
    background: #fff8e6;
    border: 1px solid #f5e2ad;
    border-radius: 8px;
    padding: 14px 16px;
    margin-bottom: 20px;
}

.validation-title {
    font-size: 13px;
    font-weight: 600;
    color: #c98a06;
}

.validation-count {
    font-size: 12px;
    font-weight: 600;
    color: #c98a06;
}

.progress-track {
    height: 6px;
    border-radius: 3px;
    background: #f5e2ad;
    overflow: hidden;
}

.progress-track-inset {
    margin-right: 40px;
}

.progress-fill {
    height: 100%;
    background: #f0a500;
    border-radius: 3px;
    transition: width 0.3s ease;
}

.validation-note {
    font-size: 12px;
    color: #a97a1f;
    margin-top: 10px;
}

.info-icon {
    margin-right: 2px;
}

.validation-progress-box-running {
    background: #eef6ff;
    border-color: #bfe0ff;
}

.validation-progress-box-running .validation-title,
.validation-progress-box-running .validation-note {
    color: #0d55c4;
}

.validation-progress-box-running .validation-count {
    color: #6c757d;
}

.validation-progress-box-running .progress-track {
    background: #cfe3fc;
}

.validation-progress-box-running .progress-fill {
    background: #1966ff;
}

.refresh-btn {
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    background: #1966ff;
    border: none;
    border-radius: 20px;
    padding: 6px 16px;
}

.refresh-btn:hover:not(:disabled) {
    background: #0d55c4;
}

.refresh-btn:disabled {
    opacity: 0.7;
}

.validation-progress-box-success {
    background: #e9f7ef;
    border-color: #b8e2c8;
}

.validation-progress-box-success .validation-title,
.validation-progress-box-success .validation-note {
    color: #1f7a3d;
}

.validation-progress-box-success .validation-count {
    color: #6c757d;
}

.validation-progress-box-success .progress-track {
    background: #c8e6d3;
}

.validation-progress-box-success .progress-fill {
    background: #1f7a3d;
}

.close-btn {
    border: none;
    background: transparent;
    color: #6c757d;
    font-size: 18px;
    line-height: 1;
    padding: 0 0 0 4px;
}

.close-btn:hover {
    color: #343a40;
}
</style>



// WEBPACK FOOTER //
// src/components/Disposal/CustomComponent/ValidationProgressBox.vue